import { render, staticRenderFns } from "./NavigatorBurger.vue?vue&type=template&id=94c87168&scoped=true&"
import script from "./NavigatorBurger.vue?vue&type=script&lang=js&"
export * from "./NavigatorBurger.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorBurger.vue?vue&type=style&index=0&id=94c87168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c87168",
  null
  
)

export default component.exports